import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface PopularPost {
  id: string;
  title: string;
  date: string;
  readTime: string;
  image: string;
  alt: string;
  slug: string;
}

interface PopularPostsProps {
  posts: PopularPost[];
}

const PopularPosts: React.FC<PopularPostsProps> = ({ posts }) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-subtle">
      <h3 className="font-headline font-semibold text-lg text-foreground mb-4 flex items-center">
        <Icon name="FireIcon" size={20} className="mr-2 text-accent" variant="solid" />
        Popular Articles
      </h3>
      <div className="space-y-4">
        {posts.map((post, index) => (
          <Link
            key={post.id}
            href={`/blog/${post.slug}`}
            className="flex gap-4 group hover:bg-muted p-3 rounded-lg transition-brand"
          >
            <div className="relative w-20 h-20 flex-shrink-0 overflow-hidden rounded-md">
              <AppImage
                src={post.image}
                alt={post.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-brand"
              />
              <div className="absolute top-1 left-1 w-6 h-6 bg-accent text-accent-foreground rounded-full flex items-center justify-center text-xs font-bold">
                {index + 1}
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="font-body font-semibold text-sm text-foreground group-hover:text-primary transition-brand line-clamp-2 mb-2">
                {post.title}
              </h4>
              <div className="flex items-center text-xs text-muted-foreground space-x-3">
                <span className="flex items-center">
                  <Icon name="CalendarIcon" size={14} className="mr-1" />
                  {post.date}
                </span>
                <span className="flex items-center">
                  <Icon name="ClockIcon" size={14} className="mr-1" />
                  {post.readTime}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PopularPosts;